import SignUp from "./SignUp";
import SignIn from "./SignIn";
import NotFound from "./NotFound";
import ComingSoon from "./ComingSoon";
import RequestUsername from "./RequestUsername";
import RequestPasswordReset from "./RequestPasswordReset";
import ResetPassword from "./ResetPassword";

import Terms from "./AcceptTerms";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false
    },
    leftSidebar: {
      show: false,
      mode: "close"
    }
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false
    },
    navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const sessionRoutes = [
  {
    path: "/session/signup",
    component: SignUp,
    settings
  },
  {
    path: "/session/signin",
    component: SignIn,
    settings
  },
  {
    path: "/session/requestusername",
    component: RequestUsername,
    settings
  },
  {
    path: "/session/requestpasswordreset",
    component: RequestPasswordReset,
    settings
  },
  {
    path: "/session/resetpassword/:token",
    component: ResetPassword,
    settings
  },
  {
    path: "/session/terms/",
    component: Terms,
    settings
  },
  {
    path: "/session/404",
    component: NotFound,
    settings
  }
  ,
  {
    path: "/comingsoon",
    component: ComingSoon,
    settings
  }
];

export default sessionRoutes;
